/* src/app/components/leads/provider-service-credentials/provider-service-credentials.css */
.ppl-mt8 h2 {
  margin: 0 0 8px 0;
  font-size: 1.25rem;
}
.credential-row {
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  display: block;
}
.credential-row .ppl-checkbox {
  display: flex;
  gap: 8px;
  font-weight: 600;
  width: 100%;
  cursor: pointer;
  text-align: left;
}
.credential-details nz-form-item {
  margin-bottom: 8px;
  width: 100%;
}
.credential-details {
  margin-top: 8px;
}
.credential-card {
  background: #ffffff;
  padding: 12px;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}
.upload-icon {
  margin-left: 0px !important;
}
.file-details {
  display: flex;
  gap: 8px;
}
.file-actions {
  display: flex;
  gap: 8px;
}
/*# sourceMappingURL=provider-service-credentials-5VC6KYE4.css.map */
